import { registerLocaleData } from "@angular/common";
import localeDe from "@angular/common/locales/de";
import localeEn from "@angular/common/locales/en";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { ChartsModule } from "@progress/kendo-angular-charts";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { DialogModule } from "@progress/kendo-angular-dialog";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { GridModule } from "@progress/kendo-angular-grid";
import { IconsModule } from "@progress/kendo-angular-icons";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { IntlModule } from "@progress/kendo-angular-intl";
import "@progress/kendo-angular-intl/locales/de/all";
import "@progress/kendo-angular-intl/locales/en/all";
import { LabelModule } from "@progress/kendo-angular-label";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { ListViewModule } from "@progress/kendo-angular-listview";
import { NotificationModule } from "@progress/kendo-angular-notification";
import { PagerModule } from "@progress/kendo-angular-pager";
import { ToolBarModule } from "@progress/kendo-angular-toolbar";
import { TooltipModule } from "@progress/kendo-angular-tooltip";
import { UploadModule } from "@progress/kendo-angular-upload";
import "hammerjs";

registerLocaleData(localeDe, "de");
registerLocaleData(localeEn, "en");

const kendoModules = [
  LayoutModule,
  LabelModule,
  InputsModule,
  ButtonsModule,
  DateInputsModule,
  GridModule,
  IntlModule,
  ToolBarModule,
  NotificationModule,
  DropDownsModule,
  UploadModule,
  BrowserModule,
  BrowserAnimationsModule,
  DialogModule,
  ChartsModule,
  IconsModule,
  ListViewModule,
  PagerModule,
  TooltipModule
];

@NgModule({
  imports: kendoModules,
  exports: kendoModules
})
export class KendoModule {}
